import { render, staticRenderFns } from "./KisDefectOverview.vue?vue&type=template&id=60f589d8"
import script from "./KisDefectOverview.js?vue&type=script&lang=js&external"
export * from "./KisDefectOverview.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports